function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Heading } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function ProjectLogoCard(param) {
    var logo = param.logo, title = param.title, action = param.action, className = param.className;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, ImageComponent = _useContext_config.ImageComponent, LinkComponent = _useContext_config.LinkComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        draggable: false,
        className: twMerge('block', action.className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "p-6 grid grid-cols-1 grid-flow-row auto-rows-max gap-5 bg-bg-subtle rounded-2xl md:p-7 transition-all outline-subtle-700 outline outline-0 hover:shadow-xl hover:shadow-subtle-700 hover:outline-1"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, logo), {
        className: twMerge('w-auto h-[6.25rem] object-contain', logo.className)
    })), /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title), !!action && /*#__PURE__*/ React.createElement("span", {
        className: twMerge('underline text-navigation-base font-semibold font-body')
    }, action.label))));
}

//# sourceMappingURL=ProjectLogoCard.js.map